import { atom } from "recoil";
import {
  DIRECTION_DOWN,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_UP,
  LOCAL_STORAGE_PLACEMENT_ID,
  LOCK_AND_KEY_COLORS,
  PLACEMENT_TYPE_CHIP,
  PLACEMENT_TYPE_CIABATTA,
  PLACEMENT_TYPE_CLOWN_DEFENSE_PICKUP,
  PLACEMENT_TYPE_CONVEYOR,
  PLACEMENT_TYPE_ENEMY,
  PLACEMENT_TYPE_ENEMY_SPAWN,
  PLACEMENT_TYPE_FIRE,
  PLACEMENT_TYPE_FIREBOOTS_PICKUP,
  PLACEMENT_TYPE_FLYING_ENEMY,
  PLACEMENT_TYPE_GOAL,
  PLACEMENT_TYPE_HERO_SPAWN,
  PLACEMENT_TYPE_ICE,
  PLACEMENT_TYPE_ICEBOOTS_PICKUP,
  PLACEMENT_TYPE_KEY,
  PLACEMENT_TYPE_LOCK,
  PLACEMENT_TYPE_ROAMING_ENEMY,
  PLACEMENT_TYPE_SWITCH,
  PLACEMENT_TYPE_SWITCH_WALL,
  PLACEMENT_TYPE_TELEPORT,
  PLACEMENT_TYPE_THIEF,
  PLACEMENT_TYPE_WALL,
  PLACEMENT_TYPE_WATER,
  PLACEMENT_TYPE_WATER_PICKUP,
  THEME_TILES_MAP,
} from "../helpers/consts";
import { TILES } from "../helpers/tiles";

export const CATEGORIES = {
  BASICS: "Basics",
  TILES: "Tiles",
  PICKUPS: "Pickups",
  ENEMIES: "Enemies",
};

export const placementSelectionOptions = [
  {
    id: "placementOptionHeroSpawn", //Selection ID to track in Atom
    type: PLACEMENT_TYPE_HERO_SPAWN, // Type of placement
    category: CATEGORIES.BASICS, // Category for knowing which <select> page to show in
    preview: TILES.HERO_SPAWN, // Tile to use in UI
  },
  {
    id: "placementOptionGoal",
    type: PLACEMENT_TYPE_GOAL,
    category: CATEGORIES.BASICS,
    preview: TILES.GOAL_ENABLED,
  },
  {
    id: "placementOptionWall",
    type: PLACEMENT_TYPE_WALL,
    category: CATEGORIES.TILES,
    preview: THEME_TILES_MAP.YELLOW.WALL,
  },
  {
    id: "placementOptionFlour",
    type: PLACEMENT_TYPE_CHIP,
    category: CATEGORIES.PICKUPS,
    preview: TILES.FLOUR,
  },
  {
    id: "placementOptionConveyorUp",
    type: PLACEMENT_TYPE_CONVEYOR,
    category: CATEGORIES.TILES,
    preview: TILES.CONVEYOR_UP,
    initialState: {
      direction: DIRECTION_UP,
    },
  },
  {
    id: "placementOptionConveyorLeft",
    type: PLACEMENT_TYPE_CONVEYOR,
    category: CATEGORIES.TILES,
    preview: TILES.CONVEYOR_LEFT,
    initialState: {
      direction: DIRECTION_LEFT,
    },
  },
  {
    id: "placementOptionConveyorDown",
    type: PLACEMENT_TYPE_CONVEYOR,
    category: CATEGORIES.TILES,
    preview: TILES.CONVEYOR_DOWN,
    initialState: {
      direction: DIRECTION_DOWN,
    },
  },
  {
    id: "placementOptionConveyorRight",
    type: PLACEMENT_TYPE_CONVEYOR,
    category: CATEGORIES.TILES,
    preview: TILES.CONVEYOR_RIGHT,
    initialState: {
      direction: DIRECTION_RIGHT,
    },
  },

  {
    id: "placementOptionWater",
    type: PLACEMENT_TYPE_WATER,
    category: CATEGORIES.TILES,
    preview: TILES.WATER1,
  },

  {
    id: "placementOptionIce",
    type: PLACEMENT_TYPE_ICE,
    category: CATEGORIES.TILES,
    preview: TILES.ICE,
    initialState: {
      corner: null,
    },
  },
  {
    id: "placementOptionIceTopLeft",
    type: PLACEMENT_TYPE_ICE,
    category: CATEGORIES.TILES,
    preview: TILES.ICE_TOP_LEFT,
    initialState: {
      corner: "TOP_LEFT",
    },
  },
  {
    id: "placementOptionIceTopRight",
    type: PLACEMENT_TYPE_ICE,
    category: CATEGORIES.TILES,
    preview: TILES.ICE_TOP_RIGHT,
    initialState: {
      corner: "TOP_RIGHT",
    },
  },
  {
    id: "placementOptionIceBottomLeft",
    type: PLACEMENT_TYPE_ICE,
    category: CATEGORIES.TILES,
    preview: TILES.ICE_BOTTOM_LEFT,
    initialState: {
      corner: "BOTTOM_LEFT",
    },
  },
  {
    id: "placementOptionIceBottomRight",
    type: PLACEMENT_TYPE_ICE,
    category: CATEGORIES.TILES,
    preview: TILES.ICE_BOTTOM_RIGHT,
    initialState: {
      corner: "BOTTOM_RIGHT",
    },
  },
  {
    id: "placementOptionIceBoots",
    type: PLACEMENT_TYPE_ICEBOOTS_PICKUP,
    category: CATEGORIES.PICKUPS,
    preview: TILES.ICE_PICKUP,
  },
  {
    id: "placementOptionFire",
    type: PLACEMENT_TYPE_FIRE,
    category: CATEGORIES.TILES,
    preview: TILES.FIRE1,
  },
  {
    id: "placementOptionFireBoots",
    type: PLACEMENT_TYPE_FIREBOOTS_PICKUP,
    category: CATEGORIES.PICKUPS,
    preview: TILES.FIRE_PICKUP,
  },
  {
    id: "placementOptionWaterPickup",
    type: PLACEMENT_TYPE_WATER_PICKUP,
    category: CATEGORIES.PICKUPS,
    preview: TILES.WATER_PICKUP,
  },
  {
    id: "placementOptionClownDefensePickup",
    type: PLACEMENT_TYPE_CLOWN_DEFENSE_PICKUP,
    category: CATEGORIES.PICKUPS,
    preview: TILES.CLOWN_DEFENSE_PICKUP,
  },
  {
    id: "placementOptionThief",
    type: PLACEMENT_TYPE_THIEF,
    category: CATEGORIES.TILES,
    preview: TILES.THIEF,
  },
  {
    id: "placementOptionTeleport",
    type: PLACEMENT_TYPE_TELEPORT,
    category: CATEGORIES.TILES,
    preview: TILES.TELEPORT1,
  },

  {
    id: "placementOptionBlueKey",
    type: PLACEMENT_TYPE_KEY,
    category: CATEGORIES.PICKUPS,
    preview: TILES.BLUE_KEY,
    initialState: {
      color: LOCK_AND_KEY_COLORS.BLUE,
    },
  },
  {
    id: "placementOptionBlueLock",
    type: PLACEMENT_TYPE_LOCK,
    category: CATEGORIES.TILES,
    preview: TILES.BLUE_LOCK,
    initialState: {
      color: LOCK_AND_KEY_COLORS.BLUE,
    },
  },
  {
    id: "placementOptionGreenKey",
    type: PLACEMENT_TYPE_KEY,
    category: CATEGORIES.PICKUPS,
    preview: TILES.GREEN_KEY,
    initialState: {
      color: LOCK_AND_KEY_COLORS.GREEN,
    },
  },
  {
    id: "placementOptionGreenLock",
    type: PLACEMENT_TYPE_LOCK,
    category: CATEGORIES.TILES,
    preview: TILES.GREEN_LOCK,
    initialState: {
      color: LOCK_AND_KEY_COLORS.GREEN,
    },
  },
  {
    id: "placementOptionSwitchButton",
    type: PLACEMENT_TYPE_SWITCH,
    category: CATEGORIES.TILES,
    preview: TILES.PURPLE_BUTTON,
  },
  {
    id: "placementOptionSwitchWallSolid",
    type: PLACEMENT_TYPE_SWITCH_WALL,
    category: CATEGORIES.TILES,
    preview: TILES.PURPLE_DOOR_SOLID,
    initialState: {
      isRaised: true,
    },
  },
  {
    id: "placementOptionSwitchWallOpen",
    type: PLACEMENT_TYPE_SWITCH_WALL,
    category: CATEGORIES.TILES,
    preview: TILES.PURPLE_DOOR_OUTLINE,
    initialState: {
      isRaised: false,
    },
  },

  {
    id: "placementOptionEnemyUp",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_UP_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_ENEMY,
      direction: DIRECTION_UP,
    },
  },
  {
    id: "placementOptionEnemyDown",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_DOWN_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_ENEMY,
      direction: DIRECTION_DOWN,
    },
  },
  {
    id: "placementOptionEnemyLeft",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_LEFT_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_ENEMY,
      direction: DIRECTION_LEFT,
    },
  },
  {
    id: "placementOptionEnemyRight",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_RIGHT_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_ENEMY,
      direction: DIRECTION_RIGHT,
    },
  },
  {
    id: "placementOptionFlyingEnemyUp",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_FLYING_UP_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_FLYING_ENEMY,
      direction: DIRECTION_UP,
    },
  },
  {
    id: "placementOptionFlyingEnemyDown",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_FLYING_DOWN_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_FLYING_ENEMY,
      direction: DIRECTION_DOWN,
    },
  },
  {
    id: "placementOptionFlyingEnemyLeft",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_FLYING_LEFT_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_FLYING_ENEMY,
      direction: DIRECTION_LEFT,
    },
  },
  {
    id: "placementOptionFlyingEnemyRight",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_FLYING_RIGHT_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_FLYING_ENEMY,
      direction: DIRECTION_RIGHT,
    },
  },
  {
    id: "placementOptionRoamingEnemy",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.ENEMY_ROAMING_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_ROAMING_ENEMY,
    },
  },
  {
    id: "placementOptionCiabatta",
    type: PLACEMENT_TYPE_ENEMY_SPAWN,
    category: CATEGORIES.ENEMIES,
    preview: TILES.CIABATTA_SPAWN,
    initialState: {
      enemyType: PLACEMENT_TYPE_CIABATTA,
    },
  },
];

export const getSelectedPlacement = (id) => {
  return placementSelectionOptions.find((o) => o.id === id);
};

const getInitialPlacementSelection = () => {
  const rememberedId = window.localStorage.getItem(LOCAL_STORAGE_PLACEMENT_ID);
  if (rememberedId && getSelectedPlacement(rememberedId)) {
    return rememberedId;
  }
  return placementSelectionOptions[0].id;
};

export const selectedPlacementAtom = atom({
  key: "selectedPlacementAtom",
  default: getInitialPlacementSelection(),
});
